"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const core_interface_1 = require("@ideal-postcodes/core-interface");
const agent_1 = require("./agent");
class Client extends core_interface_1.Client {
    /**
     * Client constructor extends CoreInterface
     *
     * Client constructor extends CoreInterface by also accepting an optional got configuration object as the second argument.
     *
     * Client uses `fetch` to power HTTP requests. You may pass a second configuration object to `Client` which will write over attributes over all Request
     */
    constructor(config, fetchConfig = {}) {
        const agent = new agent_1.Agent(fetchConfig);
        const tls = config.tls === undefined ? core_interface_1.TLS : config.tls;
        const baseUrl = config.baseUrl === undefined ? core_interface_1.API_URL : config.baseUrl;
        const version = config.version === undefined ? core_interface_1.VERSION : config.version;
        const strictAuthorisation = config.strictAuthorisation === undefined
            ? core_interface_1.STRICT_AUTHORISATION
            : config.strictAuthorisation;
        const timeout = config.timeout === undefined ? core_interface_1.TIMEOUT : config.timeout;
        const { api_key } = config;
        const interfaceConfig = {
            tls,
            api_key,
            baseUrl,
            version,
            strictAuthorisation,
            timeout,
            header: { ...config.header },
        };
        super({ agent, ...interfaceConfig });
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map